import { render } from "./compDeliveryModal.vue?vue&type=template&id=7644a068&scoped=true"
import script from "./compDeliveryModal.vue?vue&type=script&lang=js"
export * from "./compDeliveryModal.vue?vue&type=script&lang=js"

import "./compDeliveryModal.vue?vue&type=style&index=0&id=7644a068&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7644a068"]])

export default __exports__